export default class {
	constructor(selector) {
		this.element = selector;
		this.handlers = {
			render: [],
		};
		this.initObserver();
	}

	initObserver() {
		const config = {
			childList: true,
			subTree: true,
		};

		const callback = (mutationsList) => {
			const $ = jQuery;
			mutationsList.forEach((mutation) => {
				if (mutation.type === 'childList' && mutation.addedNodes) {
					mutation.addedNodes.forEach((element) => {
						if ($(element).hasClass('et_mobile_menu')) {
							this.emit('render');
						}
					});
				}
			});
		};

		this.observer = new MutationObserver(callback);
		this.observer.observe(this.element, config);
	}

	destroy() {
		this.observer.disconnect();
	}

	onRender(handler) {
		this.handlers.render.push(handler);
	}

	emit(event) {
		this.handlers[event].forEach((item) => {
			item.call(this, event);
		});
	}
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/navigation/menu-observer.js